// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageNL = {
  seo: {
    title: 'AI-transparantie | pAIoneer Labs GmbH',
    description: 'Hoe pAIoneer Labs GmbH kunstmatige intelligentie inzet en daarover informeert: AI-assistent, markering van door AI gegenereerde inhoud, redactionele verantwoordelijkheid en aanspreekpunt volgens de AI-verordening.',
    keywords: 'AI-transparantie, AI-verordening, AI Act, art.\u00a050, markering, AI-assistent, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'AI-transparantie',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'AI-transparantie',
    subtitle: 'Hoe pAIoneer Labs GmbH kunstmatige intelligentie inzet en daarover informeert.'
  },
  sections: [
    {
      title: 'Juridisch kader',
      paragraphs: [
        'Sinds 2 augustus 2026 gelden de transparantieverplichtingen van art.\u00a050 van Verordening (EU) 2024/1689 betreffende artificiële intelligentie (AI-verordening). In Duitsland is de Bundesnetzagentur (het Duitse federale agentschap voor netwerken) op grond van het KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, de Duitse wet inzake markttoezicht op AI en bevordering van innovatie) markttoezichtautoriteit en klachteninstantie voor de AI-verordening.',
        'Deze pagina beschrijft welke AI-systemen pAIoneer Labs GmbH inzet en hoe zij daarover informeert. Hoe daarbij persoonsgegevens worden verwerkt, beschrijft de privacyverklaring.'
      ]
    },
    {
      title: 'AI-assistent in onze applicatie',
      paragraphs: [
        'In onze applicatie beantwoordt een AI-assistent uw vragen. Hij is een AI-systeem: zijn antwoorden worden automatisch door taalmodellen gegenereerd en kunnen onjuist zijn. Controleer belangrijke gegevens voordat u er beslissingen op baseert.',
        'De applicatie wijst u hierop vóór uw eerste invoer en blijvend naast de chat (art.\u00a050 lid 1 AI-verordening). Bovendien is elk antwoord van de assistent machineleesbaar gemarkeerd als door AI gegenereerd (art.\u00a050 lid 2 AI-verordening).',
        'De taalmodellen worden geleverd via de dienst van OpenRouter, Inc., VS.'
      ]
    },
    {
      title: 'Directe communicatie met AI-systemen',
      paragraphs: [
        'Communiceert een AI-systeem van pAIoneer Labs GmbH rechtstreeks met u, bijvoorbeeld in een chat, dan maakt het zich uiterlijk bij de eerste interactie bekend als AI-systeem.'
      ]
    },
    {
      title: 'Inhoud van deze website',
      paragraphs: [
        'De teksten van deze website worden – ook waar AI-tools bij het opstellen ervan ondersteunen – door pAIoneer Labs GmbH gecontroleerd en onder haar redactionele verantwoordelijkheid gepubliceerd (art.\u00a050 lid 4, tweede alinea, AI-verordening).',
        'Beeld-, audio- of video-inhoud die met AI is gegenereerd of bewerkt en echte personen, plaatsen of gebeurtenissen bedrieglijk echt weergeeft, markeren wij als kunstmatig gegenereerd of bewerkt (art.\u00a050 lid 4, eerste alinea, AI-verordening).'
      ]
    },
    {
      title: 'Analyse met machine learning',
      paragraphs: [
        'Met uw toestemming analyseren wij bezoekstatistieken met methoden van machine learning; de details staan in de privacyverklaring. Daarbij gebruiken wij noch emotieherkenning noch biometrische categorisering (art.\u00a050 lid 3 AI-verordening). Het onderscheid tussen mensen en geautomatiseerde toegang berust op technische kenmerken van apparaat, browser en verbinding, niet op biometrische gegevens.'
      ]
    },
    {
      title: 'Klacht',
      paragraphs: [
        'U kunt zich met een klacht over een mogelijke inbreuk op de AI-verordening wenden tot de Bundesnetzagentur, de markttoezichtautoriteit en klachteninstantie voor de AI-verordening in Duitsland. Zij verstrekt daarover informatie op bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Contact',
    description: 'Voor vragen over de inzet van kunstmatige intelligentie kunt u ons per e-mail bereiken.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Laatst bijgewerkt: 30 oktober 2026. De Duitse versie is maatgevend.'
};
